<!--suppress HtmlUnknownTag -->
<template>
  <div>
    <b-field grouped position="is-left" style="align-items: flex-start; padding-top: 10px;">
      <b-button
        v-if="!isActiveTable"
        class="is-success"
        @click="getLeadSources"
        :disabled="!hasModifyPermission">
        EDIT SOURCES
      </b-button>
    </b-field>
    <span class="settings-text--gray" v-if="!isActiveTable">
      Last updated: {{ lastUpdatedLeadSource.email }}, {{ lastUpdatedLeadSource.paramVal }}
    </span>
    <div class="columns" v-if="isActiveTable">
      <div class="columns-error column is-12">
        <div v-if="errors.error_lone"
             class="help is-danger error-table">{{ errors.error_lone }}</div>
      </div>
    </div>
    <div class="columns" v-if="isActiveTable">
      <div class="column is-9 grid-module__grid">
        <b-table
          hoverable
          sticky-header
          v-slot="leadSources"
          class="bordered-table"
          :data="leadSources">

          <b-table-column cell-class="cell" width="20" field="ID">
            <b-field>
              <b-checkbox size="is-small" v-model="leadSources.row.showing"/>
            </b-field>
          </b-table-column>

          <b-table-column cell-class="cell" field="value" label="Name">
            {{ leadSources.row.value }}
          </b-table-column>

          <b-table-column cell-class="cell" width="150" field="sourceId" label="Link ID">
            <b-field :type="(leadSources.row.isDuplicate
                     && errors.changes === true
                     && errors.error_dbl
                     && errors.error_lone === false
                     ) ? 'is-danger' : ''"
                     :message="(leadSources.row.isDuplicate
                     && errors.changes === true
                     && errors.error_dbl
                     && errors.error_lone === false)
                     ? MSG_ERROR_DBL : ''">
              <b-input
                expanded
                size="is-normal"
                v-model="leadSources.row.linkId"
                @keydown.native="inputFiltering"
                @paste.native="pasteFiltering"
              />
            </b-field>
          </b-table-column>

        </b-table>
      </div>
      <div class="column is-3">
        <b-button outlined size="is-normal"
                  class="fix-size-button"
                  @click.native="onCancel">
          Cancel
        </b-button>
        <b-button size="is-normal" class="fix-size-button is-success"
                  :disabled="!hasModifyPermission"
                  @click.native="onSubmit">
          Submit
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import {
  getLeadSources,
  getLeadSourcesUpdateSetting, postLeadSources,
} from '@/api/settings';

const TABLE_LEAD_SOURCE = 'TLS';
const MSG_ERROR_DBL = 'Not unique Link ID';
const MSG_ERROR_LONE = 'At least one item must be selected';

export default {
  name: 'LeadSourceForm',
  data() {
    return {
      errors: {
        changes: false,
        error_dbl: false,
        error_lone: false,
      },
      leadSources: [],
      isActiveTable: false,
      isPreloading: false,
      canSaveData: true,
      errorMessage: false,
      lastUpdatedLeadSource: {
        email: '',
        paramVal: '',
      },
      activeTable: TABLE_LEAD_SOURCE,
      MSG_ERROR_DBL,
      MSG_ERROR_LONE,
    };
  },
  watch: {
    leadSources: {
      deep: true,
      handler() {
        this.errors.changes = false;
        const allFalse = this.leadSources.every((item) => !item.showing);
        this.canSaveData = allFalse;
        if (allFalse !== true) {
          this.errorMessage = false;
        }
        this.checkDuplicates();
      },
    },
  },
  async mounted() {
    this.getLeadSourceLastUpdate();
  },
  computed: {
    ...mapGetters(['hasAccess']),
    hasModifyPermission() {
      const permission = { resource: 'manage-settings', code: 'modify' };
      return this.hasAccess(permission, permission, true);
    },
  },
  methods: {
    hasDuplicates() {
      return this.leadSources.some((source) => {
        if (source.isDuplicate) {
          this.errors.error_dbl = MSG_ERROR_DBL;
          return true;
        }
        return false;
      });
    },
    async onSubmit() {
      this.errors.changes = true;
      const allFalse = this.leadSources.every((item) => !item.showing);
      if (allFalse === true) {
        this.errors.error_lone = MSG_ERROR_LONE;
      } else {
        this.errors.error_lone = false;
      }
      if (this.hasDuplicates()) {
        this.errors.error_dbl = MSG_ERROR_DBL;
      } else {
        this.errors.error_dbl = false;
      }
      if (this.errors.error_lone === false && this.errors.error_dbl === false) {
        await this.onLeadSourceSubmit();
      }
    },
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },
    checkDuplicates() {
      const counts = new Map();
      this.leadSources.forEach((source) => {
        if (source.linkId) {
          const linkIdStr = source.linkId.toString();
          counts.set(linkIdStr, (counts.get(linkIdStr) || 0) + 1);
        }
      });
      this.leadSources.forEach((source) => {
        if (source.linkId) {
          const linkIdStr = source.linkId.toString();
          // eslint-disable-next-line
          source.isDuplicate = counts.get(linkIdStr) > 1;
        } else {
          // eslint-disable-next-line
          source.isDuplicate = false;
        }
      });
    },
    async getLeadSourceLastUpdate() {
      const { data } = await getLeadSourcesUpdateSetting();
      this.lastUpdatedLeadSource = _.get(data, 'data.0', 'Invalid Response');
    },
    async getLeadSources() {
      this.isActiveTable = true;
      this.isPreloading = true;
      const { data: { data } } = await getLeadSources();
      this.leadSources = data;
      this.isPreloading = false;
    },
    /**
     * Until 40 - control keys {arrows, backspace, delete, home ...}
     * Between 48-57 - numbers
     * Between 96-105 - numbers numlock
     * 46 - DEL key
     * 67,86,88,90 - Ctrl+{c,z,x,v}
     */
    inputFiltering(event) {
      const isInvalid = (keyCode) => keyCode === 32 || ((((keyCode < 48 || keyCode > 57)
          && (keyCode < 96 || keyCode > 105)))
        && keyCode !== 46) || event.shiftKey === true;

      const isCvCc = () => [67, 86, 88, 90].includes(event.keyCode)
        && event.ctrlKey === true;

      const isControl = () => event.keyCode !== 32 && (event.keyCode < 40 || event.keyCode === 46);

      const isSelection = () => event.target.selectionStart - event.target.selectionEnd !== 0;

      if (isControl() || isCvCc()) {
        // eslint-disable-next-line no-restricted-globals
        return;
      }

      if (isSelection() && !isInvalid(event.keyCode)) {
        return;
      }

      if (isInvalid(event.keyCode) || event.target.value.length > 8) {
        event.preventDefault();
      }
    },

    pasteFiltering(event) {
      const paste = event.clipboardData || window.clipboardData;
      const data = paste.getData('text');
      const { value } = event.target;

      if (!data.match('^\\d{0,9}$')) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 9',
          type: 'is-warning',
        });
      }

      if ((value.length - (event.target.selectionEnd - event.target.selectionStart)
        + data.length) > 9) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 9',
          type: 'is-warning',
        });
      }
    },
    onCancel() {
      this.errors = {
        changes: false,
        error_dbl: false,
        error_lone: false,
      };
      this.isActiveTable = false;
    },
    async onLeadSourceSubmit() {
      this.isPreloading = true;
      try {
        const { data } = await postLeadSources(this.leadSources);
        if ('error' in data) {
          this.toast(_.get(data, 'error'), 'is-danger');
        } else if (_.some(data, (row) => _.get(row, 'double', false))) {
          this.leadSources = data;
        }
        const responseLastUpdate = await getLeadSourcesUpdateSetting();
        this.lastUpdatedLeadSource = _.get(responseLastUpdate, 'data.data.0');
      } catch (e) {
        this.toast('Something wrong', 'is-danger');
      } finally {
        this.isPreloading = false;
        this.isActiveTable = false;
      }
    },
  },

};
</script>

<style lang="stylus" scoped>
.columns-error
  height 10px
  padding-top 0
.bordered-table
  td:first-child
    border-left 1px solid rgba(143, 167, 179, 0.3)
  td:last-child
    border-right 1px solid rgba(143, 167, 179, 0.3)
.cell
  white-space inherit
.fix-size-button
  width 80px
  margin-bottom 8px
  margin-right 8px
</style>
